
import '../scss/btf/btf.scss';

import { Menu } from './components/menu/menu';
import { LanguagesSwitcher } from "./components/languages-switcher/languages-switcher";
import { Header } from "./components/header/header";
import { Scrub } from "./components/scrub/scrub";


document.addEventListener('DOMContentLoaded', () => {

	if ( document.querySelector('.menu-btn') ) {
		Menu.setupMenu();
	}

	if ( document.querySelector('header') ) {
		new Header();
	}

	if (document.querySelector('.languages-switcher')) {
		new LanguagesSwitcher( document.querySelector('.languages-switcher') );
	}

	if (document.querySelector('.scrub')) {
		new Scrub();
	}

	const modals: any = {};

	if (document.querySelectorAll('.open-modal-trigger').length > 0 ) {
		import('./components/modal/modal').then(m => {
			document.querySelectorAll('.open-modal-trigger').forEach( (openModalTrigger: HTMLElement) => {
				if ( document.getElementById(openModalTrigger.dataset.modalId) ) {
					modals[openModalTrigger.dataset.modalId] = new m.Modal( openModalTrigger, document.getElementById(openModalTrigger.dataset.modalId) );
				}
			});
		} );
	}

	if (document.querySelectorAll('.next-modal').length > 0 ) {
		document.querySelectorAll('.next-modal').forEach( (nextModalTrigger: HTMLButtonElement ) => {
			nextModalTrigger.addEventListener('click', (ev: MouseEvent) => {
				ev.preventDefault();
				const modalToOpen = nextModalTrigger.dataset.modalId;
				const currentModal = document.querySelector('.modal.active');
				modals[currentModal.getAttribute('id')].closeModal();
				modals[modalToOpen].openModal();
			});
		});
	}


	if ( document.querySelector('.accordion') ) {
		import('./components/accordion/accordion').then( c => { new c.Accordion( document.querySelector('.accordion') ); });
	}

	if ( document.body.classList.contains('page-template-template-home') ) {

		import('./pages/home/home').then(c => new c.Home() );

	} else if ( document.body.classList.contains('page-template-template-about') ) {

		import('./pages/about/about').then(c => new c.About() );

	} else if ( document.body.classList.contains('page-template-template-painting') ) {

		import('./pages/painting/painting').then(c => new c.Painting() );

	} else if ( document.body.classList.contains('page-template-template-service') ) {

		import('./pages/service/service').then(c => new c.Service() );

	} else if ( document.body.classList.contains('page-template-template-contact') ) {

		import('./pages/contacts/contacts').then(c => new c.Contacts() );

	} else {

		import('./pages/page').then(c => {
			const p = new c.Page();
			p.pageSetup();
			p.pageReady();
		});

	}


}, false);
